const API_KEY = process.env.REACT_APP_API_KEY

const requests = {
    fetchTrending:`/trending/all/week?api_key=${API_KEY}&language-en-US`,
    fetchNetflixOriginals:`/discover/tv?api_key=${API_KEY}&with_network=213`,
    fetchTopRatedMovies:`/movie/top_rated?api_key=${API_KEY}`,
    fetchActionMovies:`/discover/movie?api_key=${API_KEY}&with_genres=28`,
    fetchComedyMovies:`/discover/movie?api_key=${API_KEY}&with_genres=35`,
    fetchHorrorMovies:`/discover/movie?api_key=${API_KEY}&with_genres=27`,
    fetchRomanceMovies:`/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    fetchDcoumentaries:`/discover/movie?api_key=${API_KEY}&with_genres=99`,
    fetchTvShows:`/trending/tv/week?api_key=${API_KEY}`
}


export default requests